import { render, staticRenderFns } from "./UnitForm.vue?vue&type=template&id=255d7e96&"
import script from "./UnitForm.vue?vue&type=script&lang=js&"
export * from "./UnitForm.vue?vue&type=script&lang=js&"
import style0 from "./UnitForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports